import React from 'react';
import PropTypes from 'prop-types';
import HeaderComponent from './HeaderComponent';
import './style.scss';

const HeaderContainer = ({ selectedOrganization }) => {
    return <HeaderComponent selectedOrganization={selectedOrganization} />;
};

HeaderContainer.propTypes = {
    selectedOrganization: PropTypes.shape({
        organizationID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isPowertrainOrganization: PropTypes.bool
    })
};

export default HeaderContainer;
